import styled from 'styled-components'
import {white, airBlueLight} from '@modifi/colors'
import {media} from '@modifi/ui'

const formSmLeftRightPadding = '8'
const formMdLeftRightPadding = '24'
const formMdBottomPadding = '24'

export const FormContainer = styled.div`
  box-shadow: 0px 3px 20px rgba(96, 108, 116, 0.13);
  min-height: 55vh;
  position: relative;
  border-radius: 6px;
  background: ${white};
  padding: 16px ${formSmLeftRightPadding}px 0 ${formSmLeftRightPadding}px;

  ${media.md`
    padding: 24px ${formMdLeftRightPadding}px ${formMdBottomPadding}px ${formMdLeftRightPadding}px;
  `}
`

export const BaseFormFooterContainer = styled.div`
  position: sticky;
  height: 80px;
  bottom: 0px;
  left: 0px;
  margin-right: -${formSmLeftRightPadding}px;
  margin-left: -${formSmLeftRightPadding}px;

  ${media.md`
    margin: 0 -${formMdLeftRightPadding}px -${formMdBottomPadding}px -${formMdLeftRightPadding}px;
  `}
`

export const FormFooterContainer = styled(BaseFormFooterContainer)`
  background: ${airBlueLight};
`

export const FormContentWrapper = styled.div`
  min-height: 55vh;
`
